import * as React from "react";
import OptionsPopoverItem from "./OptionsPopoverItem";
import { cx } from "utils/join-classnames";
import { Button, Tooltip } from "ui/components";
import { IconNames, Option } from "core/models";
import styles from "./FragmentCard.module.scss";

interface Props {
    options: Option[];
    icon: IconNames;
    disabled?: boolean;
    orientation?: "left" | "right";
    className?: string;
    tooltip?: string;
    buttonType?: "function" | "icon";
}

const OptionsPopover: React.FC<Props> = ({
    options,
    icon,
    disabled,
    orientation = "right",
    className,
    tooltip,
    buttonType = "function",
}: Props) => {
    const optionsJSX = options.map((option) => (
            <OptionsPopoverItem
                key={JSON.stringify(option)}
                title={option.title}
                icon={option.icon}
                onClick={option.onClick}
                disabledText={option.disabledText}
                disabled={option.disabled}
                tooltip={option.tooltip}
                sharedOnSocial={option.shared}
            />
        ));
    return (
        <Tooltip text={tooltip || ""} disabled={!tooltip}>
            <div
                className={cx(
                    styles.item__footer__button,
                    styles.is__end,
                    styles.item__footer__dropdown__button,
                    className,
                )}
            >
                <Button
                    type={buttonType}
                    theme="light"
                    icon={icon}
                    className={styles.item__footer__icon}
                    disabled={disabled}
                />

                <div
                    className={cx(
                        styles.item__footer__options,
                        styles.options,
                        orientation === "left" ? styles.options__left : null,
                    )}
                >
                    <div className={styles.triangle} />
                    <div className={styles.options__inner}>{optionsJSX}</div>
                </div>
            </div>
        </Tooltip>
    );
};

export default React.memo(OptionsPopover);
